import React from "react";
import {
  createTheme,
  ThemeProvider,
  Box,
  Container,
  Grid,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import "../ATC-Cluster/Emea.css";

const Emea = () => {
  const localTheme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });

  const allRegions = [
    {
      title: "East/Central",
      countries: [
        { name: "Bulgaria", flag: "Bulgaria.png" },
        { name: "Czech Republic", flag: "Czech Republic.png" },
        { name: "Hungary", flag: "Hungary.png" },
        { name: "Poland", flag: "Poland.png" },
        { name: "Romania", flag: "Romania.png" },
        { name: "Slovakia", flag: "Slovakia.png" },
      ],
      columns: 2,
    },
    {
      title: "West",
      countries: [
        { name: "France", flag: "France.png" },
        { name: "Morocco", flag: "Morocco.png" },
        { name: "Mauritius", flag: "Mauritius.png" }
      ],
      columns: 2,
    },
    {
      title: "UKIA",
      countries: [
        { name: "Newcastle & Regional", flag: "Newcastle and regional.png" },
        { name: "South Africa", flag: "South Africa.png" },
      ],
      columns: 2,
    },
    {
      title: "Egypt",
      countries: [{ name: "Cairo", flag: "Cairo.png" }],
      columns: 1,
    },
    {
      title: "North",
      countries: [
        { name: "Latvia", flag: "Latvia.png" },
        { name: "Lithuania", flag: "Lithuania.png" },
      ],
      columns: 2,
    },
    {
      title: "South",
      countries: [
        { name: "Portugal", flag: "Portugal.png" },
        { name: "Spain", flag: "Spain.png" },
      ],
      columns: 2,
    },
    {
      title: "Italy",
      countries: [{ name: "Italy", flag: "Italy.png" }],
      columns: 1,
    },
  ];

  return (
    <ThemeProvider theme={localTheme}>
      <div className="main-banner">
        <img
          src="images/Home/banner-home.png"
          alt="banner"
          className="banner-img"
        />
      </div>

      <Container sx={{ marginBottom: "5%" }} maxWidth={false} disableGutters>
        <Box sx={{ width: "90%", margin: "auto" }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 2, mb: 2 }}
          >
            <MuiLink href="/home" underline="hover">
              <img
                src="images/Home/home_icon.png"
                alt="Home"
                className="home-icon"
              />
            </MuiLink>{" "}
            / <span style={{ textDecoration: "underline" }}>EMEA</span>
          </Typography>
        </Box>

        <Box className="coverage_box">
          <Box sx={{ width: "90%", margin: "auto", position: "relative"}}>
            <Typography
              variant="h4"
              color="primary"
              gutterBottom
              className="atc-header"
            >
              Coverage in EMEA
            </Typography>
          <div className="header_line_emea">
            <img src="images/Home/header_line.png" alt="header_line" className="header_line_img"/>
          </div>
            <Grid
              container
              spacing={4}
              className="emea-region-grid"
              sx={{ rowGap: 6 }}
            >
              {allRegions.map((region) => (
                <Grid item xs={12} sm={6} md={3} key={region.title}>
                  <Box className="coverage_card">
                    <img
                      src="images/Home/bg_img_card.png"
                      alt="card background"
                      className="card_img_emea"
                    />
                    <h3 className="region_header">{region.title}</h3>
                    <Box
                      className="emea-country-grid"
                      style={{
                        display: "grid",
                        gridTemplateColumns: `repeat(${region.columns}, 1fr)`,
                      }}
                    >
                      {region.countries.map((country) => (
                        <Box key={country.name} className="emea-country-item">
                          <img
                            src={`images/Home/${country.flag}`}
                            alt={country.name}
                            className="emea-flag"
                          />
                          <Typography
                            variant="body2"
                            className="emea-country-name"
                          >
                            {country.name}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default Emea;
